class BootstrapSlider {

    constructor() {
        $('.slider').slider({
            tooltip: 'always',
        });
    }

}
